<template>
  <form @submit.prevent>
    <CModal
        :closeOnBackdrop ="false"
        :title.sync="title"
        color="info"
        :show.sync="show">
        <CRow>
          
          <CCol>
            
             <label > Target  </label>
             <CRow >
              <CCol  >
              <b-form-select v-model="form.target"  :options="options_target"></b-form-select>
             <CCol class="mt-2" v-if="mode === 'edit'">
              {{ "Previous Target: " }} <b> {{  prevtarget }} </b>
              </CCol>      
              </CCol>        
            </CRow>
            <hr>
            <label  > Required Class  </label> 
         <CRow>
          <CCol>
            
            <div v-for="d in options_class" :key="d.value">
            <b-form-checkbox type="checkbox"  :value="d.value" v-model="form.classes">
            {{ d.text }}
            </b-form-checkbox>
            </div>
          </CCol> 
          </CRow> 
           

           
          </CCol> 
          </CRow>

        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.id)"  variant="outline" color="info">Edit</CButton>
      </template>
      
    </CModal>
  </form>
  
</template>

<script>
import EventBus from '@/eventBus';

import rule from '@/services/rule'
import general from '@/services/generalclass';
import Multiselect from 'vue-multiselect'

export default {
name: 'keperluanmodal',
components: { Multiselect },

  data () {
    return {
        
        value: [],
      show: false,
      title: 'Default Title',
      mode: '',
      form:{
        uuid: '',
        target: '',

        classes:[],
    
      },
      options_target:[],
      options_class:[],
      classes:[],
      temp:'',
      prevtarget: '',
    }
  },
  computed: {

   },
  mounted(){
    
  },
  created () {
   
    var self = this;
    EventBus.$on('OPEN_MODAL_SYSTEM_RULES', (params) => {
      this.getTargetRule()
      if(params.data){
        rule.getRulebyID(params.data)
        .then(res => {
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          self.form.id = res.data.id;
          self.form.target = res.data.target;
          self.form.classes = JSON.parse(res.data.requirements);
          self.prevtarget = res.data.target;
          //self.temp = self.options_target[1].value
          self.temp = self.options_target.findIndex(x => x.text === "iCare Coach")
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = ""; 
        self.form.target = "";
        self.form.classes = [];
      }
    });

      //options class
      this.form.id = this.$route.query.Pud
      general.getGeneral()
      .then(res => {
        for (let i=0; i <= res.data.length; i++){
          //alert
          this.temp = String(res.data[i].id)
          this.options_class.push({text: res.data[i].name, value: this.temp})
        }
      }).catch((er) =>{
      })
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    className ({ text }) {
      return `${text}`
    },
    create(){
    
      this.show = false;
      rule.createRule(this.form)
     
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
       console.log(this.form)
    },
    update(id){
      this.show = false;
      rule.updateRule(id, this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    getTargetRule(){
     //options target
     this.options_target = []
      rule.getRulebyTarget()
      .then(res => {
          for (let i=0; i <= res.notin.length -1; i++){
            //alert
            this.options_target.push({text:res.notin[i] , value:res.notin[i]})
          }
        }).catch((er) =>{
      })
    },
  }
}
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>